import api from '../token';

export const AlterBanco = async (dados) => {
  try {
    const response = await api.post('/alterBanco', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};